/**
 * Type definitions for the Cases feature
 */

/**
 * Represents the status of a case
 */
export enum CaseStatus {
  OPEN = 'open',
  IN_PROGRESS = 'in_progress',
  PENDING = 'pending',
  CLOSED = 'closed',
  ARCHIVED = 'archived'
}

/**
 * Represents the client assignment options for multi-tenant portal system
 */
export enum ClientAssignment {
  CRAIG = 'craig',
  JOHNSON_LAW = 'johnson_law',
  SMITH_INSURANCE = 'smith_insurance',
  MARTINEZ_LEGAL = 'martinez_legal',
  BROWN_ASSOCIATES = 'brown_associates'
}

/**
 * Client display names for the dropdown
 */
export const CLIENT_DISPLAY_NAMES: Record<ClientAssignment, string> = {
  [ClientAssignment.CRAIG]: 'Craig (Admin)',
  [ClientAssignment.JOHNSON_LAW]: 'Johnson Law Firm',
  [ClientAssignment.SMITH_INSURANCE]: 'Smith Insurance Group',
  [ClientAssignment.MARTINEZ_LEGAL]: 'Martinez Legal Services',
  [ClientAssignment.BROWN_ASSOCIATES]: 'Brown & Associates'
};

/**
 * Represents a case in the system
 */
export interface Case {
  id: string;
  case_number: string; // Maps to reference_number in the database
  title: string;
  description: string;
  status: CaseStatus;
  client_name: string;
  client_email: string;
  client_phone: string;
  at_fault_insurer?: string | null;
  assigned_bike_id?: string | null;
  collecting_for_client: ClientAssignment;
  created_at: string;
  last_modified: string;
  documents_count: number;
}

/**
 * Financial information related to a case
 */
export interface CaseFinancials {
  caseId: string;
  invoicedAmount: number;
  reserveAmount: number;
  settlementAmount: number;
  paidAmount: number;
}

/**
 * Props for case-related components
 */
export interface CaseComponentProps {
  caseId: string;
  onSuccess?: () => void;
  onCancel?: () => void;
  onUpdate?: () => void;
}

/**
 * New case creation data
 */
export interface NewCaseData {
  title: string;
  description: string;
  client_name: string;
  client_email: string;
  client_phone: string;
  status: CaseStatus;
  collecting_for_client: ClientAssignment;
}

/**
 * Case update data
 */
export interface UpdateCaseData {
  title?: string;
  description?: string;
  client_name?: string;
  client_email?: string;
  client_phone?: string;
  status?: CaseStatus;
  collecting_for_client?: ClientAssignment;
}
